<template>
    <div class="sr-date-picker">
        <SrMenu
            ref="menu"
            v-model="showDatePicker"
            nudge-bottom="60"
            :close-on-content-click="false"
            :transition="transition"
            attach
        >
            <template #activator="{ on }">
                <VTextField
                    :class="classList"
                    :value="formattedDate"
                    :clearable="clearable"
                    :label="label"
                    readonly
                    outlined
                    @input="reset"
                    v-on="on"
                />
            </template>
            <VDatePicker
                v-model="internalDates"
                :type="type"
                :locale="locale"
                :range="range"
                :multiple="multiple"
                width="250"
                no-title
            />
        </SrMenu>
    </div>
</template>

<script>
import SrMenu from '../SrMenu/SrMenu';

import { USER_INPUT_CLASS } from '../../utils/classNames';

export default {
    name: 'SrDatePicker',
    components: { SrMenu },
    props: {
        label: {
            type: String,
            default: 'Period',
        },

        clearable: {
            type: Boolean,
            default: false,
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        // Todo: implement
        range: {
            type: Boolean,
            default: false,
        },

        formatDate: {
            type: Function,
            default: ({ dates, isMultiSelect }) => {
                const firstDate = isMultiSelect ? dates[0] : dates;

                const dateObject = new Date(firstDate);
                const month = dateObject.toLocaleString('default', { month: 'short' });
                const year = dateObject.toLocaleString('default', { year: 'numeric' });

                let formattedDate = `${month}, ${year}`;

                if (isMultiSelect && dates.length > 1) {
                    let monthString = 'month';
                    const otherMonthsLength = dates.length - 1;

                    if (otherMonthsLength > 1) {
                        monthString = 'months';
                    }

                    formattedDate += ` (+ ${otherMonthsLength} other ${monthString})`;
                }

                return formattedDate;
            },
        },

        // Todo: extract into mixin
        locale: {
            type: String,
            default: 'en-GB',
        },

        transition: {
            type: String,
            default: 'scale-transition',
        },

        type: {
            type: String,
            default: 'month',
        },
    },

    data() {
        return {
            showDatePicker: false,
            internalDates: [],
        };
    },

    computed: {
        isMultiSelect() {
            return this.multiple || this.range;
        },

        isDatesEmpty() {
            if (this.isMultiSelect) {
                return this.internalDates.length === 0;
            }

            return this.internalDates === '';
        },

        dates() {
            if (this.isDatesEmpty) {
                return [];
            }

            const clonedDates = JSON.parse(JSON.stringify(this.internalDates));

            if (this.isMultiSelect) {
                return clonedDates.sort();
            }

            return clonedDates;
        },

        formattedDate() {
            if (this.isDatesEmpty) {
                return '';
            }

            return this.formatDate(this);
        },

        classList() {
            return [USER_INPUT_CLASS];
        },
    },

    watch: {
        dates(newDates) {
            this.$emit('input', newDates);
        },
    },

    created() {
        this.reset();
    },

    methods: {
        reset() {
            this.internalDates = this.isMultiSelect ? [] : '';
        },
    },
};
</script>
